import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import OnboardingShell from "../OnboardingShell";
import BottomButton from "../BottomButton";
import { FONTS, CARD_STYLES } from "../../constants/styles";
import MonetizationOnRoundedIcon from "@mui/icons-material/MonetizationOnRounded";
import LinkRoundedIcon from "@mui/icons-material/LinkRounded";
import BarChartRoundedIcon from "@mui/icons-material/BarChartRounded";

const BenefitCard = ({
    icon,
    iconBg,
    title,
    description,
    delay,
}: {
    icon: React.ReactNode;
    iconBg: string;
    title: string;
    description: string;
    delay: number;
}) => (
    <Box
        sx={{
            ...CARD_STYLES,
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            "@keyframes staggerIn": {
                from: { opacity: 0, transform: "translateY(12px)" },
                to: { opacity: 1, transform: "translateY(0)" },
            },
            animation: `staggerIn 0.35s ease-out ${delay}ms both`,
        }}
    >
        <Box
            sx={{
                width: 40,
                height: 40,
                borderRadius: "12px",
                bgcolor: iconBg,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flex: "0 0 auto",
            }}
        >
            {icon}
        </Box>
        <Stack spacing={0.25} sx={{ flex: 1, minWidth: 0 }}>
            <Typography
                sx={{
                    fontFamily: FONTS.display,
                    fontWeight: 600,
                    fontSize: "15px",
                    lineHeight: 1.3,
                }}
            >
                {title}
            </Typography>
            <Typography
                sx={{
                    fontFamily: FONTS.body,
                    fontWeight: 400,
                    fontSize: "13px",
                    color: "text.secondary",
                    lineHeight: 1.4,
                }}
            >
                {description}
            </Typography>
        </Stack>
    </Box>
);

const AffiliateLanding = () => {
    return (
        <OnboardingShell
            variant="landing"
            heroTitle="Become a Partner"
            heroSubtitle="Earn with Jemloc"
        >
            <Typography
                sx={{
                    fontFamily: FONTS.body,
                    fontSize: "14px",
                    color: "text.secondary",
                    textAlign: "center",
                    px: 1,
                }}
            >
                Refer other professionals to Jemloc and earn recurring
                commission on every paid subscription.
            </Typography>
            <Stack spacing={1.5} sx={{ width: "100%" }}>
                <BenefitCard
                    icon={
                        <MonetizationOnRoundedIcon
                            sx={{ color: "white", fontSize: 22 }}
                        />
                    }
                    iconBg="#4CAF50"
                    title="20% recurring commission"
                    description="Earn on every active subscription your referrals maintain."
                    delay={0}
                />
                <BenefitCard
                    icon={
                        <LinkRoundedIcon
                            sx={{ color: "white", fontSize: 22 }}
                        />
                    }
                    iconBg="#2196F3"
                    title="Unique referral link"
                    description="Get your personal link to share with potential clients."
                    delay={60}
                />
                <BenefitCard
                    icon={
                        <BarChartRoundedIcon
                            sx={{ color: "white", fontSize: 22 }}
                        />
                    }
                    iconBg="#FF9800"
                    title="Track your earnings"
                    description="Monitor your referrals and commissions in the partner dashboard."
                    delay={120}
                />
            </Stack>
            <BottomButton
                onClick={() => (window.location.href = "/affiliate/signup")}
                sticky
            >
                Get Started
            </BottomButton>
        </OnboardingShell>
    );
};

export default AffiliateLanding;
